export default __webpack_public_path__ + "static/media/powered-by-doselect.189c8576.svg";